export const calculateReadingTime = (
  contentLead?: string,
  contentTop?: string,
  contentMiddle?: string,
  contentQuote?: string,
  contentBottom?: string
): number => {
  const wordsPerMinute = 200
  const textContent = [
    contentLead,
    contentTop,
    contentMiddle,
    contentQuote,
    contentBottom,
  ]
    .filter((s) => s && s.trim() !== '')
    .join(' ')

  if (!textContent.trim()) {
    return 0
  }

  const wordCount = textContent
    .split(/\s+/)
    .filter((word) => word.length > 0).length

  if (wordCount === 0) {
    return 0
  }

  const readingTime = Math.ceil(wordCount / wordsPerMinute)
  return readingTime
}
